import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The Craft",
    body: "Every recipe is developed by pastry chefs and stress-tested for a busy pass. Real butter, real chocolate, no shortcuts — only the process is simplified.",
  },
  {
    n: "02",
    title: "Built for Service",
    body: "Frozen, chilled and ambient formats that thaw, bake or plate in minutes. Consistent portions, consistent margins, zero guesswork for your team.",
  },
  {
    n: "03",
    title: "Delivered",
    body: "From sampling to standing order, we supply hotels, restaurants and cafés with a dependable rhythm — packed to survive the journey and land beautifully.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-20 md:py-32 bg-[#F5F2EB] border-y border-[#E6E2D8]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal className="mb-14 md:mb-20 max-w-3xl">
        <p className="text-xs tracking-[0.3em] uppercase font-medium text-[#B07D4E] mb-5">How We Work</p>
        <h2 className="font-display text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] text-[#2A221C]">
          Ideas to impact.<br /><span className="italic text-[#D4A373]">Flavour to remember.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E6E2D8] border border-[#E6E2D8]">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.12} className="bg-[#F5F2EB] p-8 md:p-10 relative min-h-[280px] md:min-h-[360px] flex flex-col">
            <span className="font-display text-7xl md:text-8xl leading-none text-[#D4A373]/35 select-none">{c.n}</span>
            <h3 className="font-display text-3xl md:text-4xl text-[#2A221C] mt-6 mb-4">{c.title}</h3>
            <p className="font-light text-[#2A221C]/70 leading-relaxed">{c.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
